export const nameGenerator = (n: {data: {shortName?:string, text: string}}) =>
  (n.data.shortName ? n.data.shortName : n.data.text);


